<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
	[titleHeaderText]="'label.coil.calculator'| translate">
</copo-panel-header>
<div class="calculator-informations-block">
	<div class="calculator-details-text" translate>coil.calculator.tool.text</div>
	<div class="calculator-details-text" translate>coil.calculator.density.text</div>
	<div class="calculator-details-text" translate>coil.calculator.technical.feasibility.text</div>
	<div class="calculator-block-info-grid">
		<button mat-flat-button type="button" color="primary" (click)="organicCoatedSteelSelected()"
			[class.copo-button-selection-selected]="coilCalculator.calculationType !== 'organicCoatedSteel'">
			<span translate>coil.calculator.organic.coated.coils</span>
		</button>
		<button mat-flat-button type="button" color="primary" (click)="hotOrColdRolledSelected()"
			[class.copo-button-selection-selected]="coilCalculator.calculationType === 'organicCoatedSteel'">
			<span translate>coil.calculator.all.other.coils</span>
		</button>
	</div>
	<form [formGroup]="coilCalculatorFormGroup">
		<div class="calculator-block-subtitle" translate>
			coil.calculator.product.information</div>
		<div class="calculator-block-info-grid">
			<mat-form-field>
				<mat-label translate>coil.calculator.nominal.thickness.label</mat-label>
				<input type="text" matInput copoInputNumber spellcheck="false"
					autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
					[formControl]="nominalThicknessFormControl" (input)="nominalThicknessChanged($event)" required>
				<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
				</mat-icon>
				<mat-error *ngIf="nominalThicknessFormControl.hasError('required')">
					<span translate>coil.calculator.nominal.thickness.mandatory</span>
				</mat-error>
			</mat-form-field>
			<ng-container *ngIf="coilCalculator.calculationType === 'organicCoatedSteel'">
				<mat-form-field class="copo-form-field">
					<mat-label translate>coil.calculator.metallic.coating.type.label</mat-label>
					<mat-select placeholder="metallic coating type" [formControl]="metallicCoatingTypeFormControl"
						(selectionChange)="metallicCoatingTypeChanged($event)" required>
						<mat-option *ngFor="let metallicCoatingType of metallicCoatingTypeValues"
							[value]="metallicCoatingType.key">{{metallicCoatingType.value.label}}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="metallicCoatingTypeFormControl.hasError('required')">
						<span translate>coil.calculator.metallic.coating.type.mandatory</span>
					</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label translate>coil.calculator.metallic.coating.thickness.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
						[formControl]="metallicCoatingThicknessFormControl" (input)="metallicCoatingThicknessChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
			</ng-container>
		</div>
		<div class="calculator-block-info-grid">
			<ng-container *ngIf="coilCalculator.calculationType === 'organicCoatedSteel'">
				<mat-form-field>
					<mat-label translate>coil.calculator.total.paint.thickness.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
						[formControl]="totalPaintThicknessFormControl" (input)="totalPaintThicknessChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
				<mat-form-field>
					<mat-label translate>coil.calculator.organic.coated.film.thickness.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
						[formControl]="organicCoatedFilmThicknessFormControl" (input)="organicCoatedFilmThicknessChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
			</ng-container>
		</div>
		<div class="calculator-block-subtitle" translate>coil.calculator.input.parameters</div>
		<div class="calculator-block-info-grid">
			<mat-form-field class="copo-form-field">
				<mat-label translate>coil.calculator.inner.diameter.label</mat-label>
				<mat-select placeholder="inner diameter" [formControl]="innerDiameterFormControl"
					(selectionChange)="innerDiameterChanged($event)" required>
					<mat-option *ngFor="let innerDiameter of innerDiameterOptionsValues"
						[value]="innerDiameter">{{innerDiameter}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="innerDiameterFormControl.hasError('required')">
					<span translate>coil.calculator.inner.diameter.mandatory</span>
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label translate>coil.calculator.width.label</mat-label>
				<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off"
					[maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
					[formControl]="widthFormControl" (input)="widthChanged($event)" required>
				<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
				</mat-icon>
				<mat-error *ngIf="widthFormControl.hasError('required')">
					<span translate>coil.calculator.width.mandatory</span>
				</mat-error>
			</mat-form-field>
		</div>
		<div class="calculator-block-subtitle" translate>coil.calculator.additional.data</div>
		<mat-radio-group name="additional-coil-data" labelPosition="after"
			[formControl]="additionalDataChoiceFormControl" (change)="additionalDataChoiceChanged($event)">
			<div class="calculator-block-info-grid">
				<mat-radio-button value="coilOuterDiameter" class="calculator-block-info-item">
					<span translate>coil.calculator.outer.diameter</span>
				</mat-radio-button>
				<mat-form-field
					*ngIf="additionalDataChoiceFormControl.value === 'coilOuterDiameter'">
					<mat-label translate>coil.calculator.outer.diameter.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
						[formControl]="additionalDataOuterDiameterFormControl" [errorStateMatcher]="instantMatcher"
						(input)="additionalDataChanged($event)" required>
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
					<mat-error *ngIf="additionalDataOuterDiameterFormControl.hasError('required')">
						<span translate>coil.calculator.outer.diameter.mandatory</span>
					</mat-error>
					<mat-error
						*ngIf="!additionalDataOuterDiameterFormControl.hasError('required') && coilCalculatorFormGroup.hasError('inner-greater-than-outer')"
						translate>coil.calculator.outer.less.than.inner.error</mat-error>
				</mat-form-field>
			</div>
			<div class="calculator-block-info-grid">
				<mat-radio-button value="coilWeight" class="calculator-block-info-item">
					<span translate>coil.calculator.weight</span>
				</mat-radio-button>
				<mat-form-field
					*ngIf="additionalDataChoiceFormControl.value === 'coilWeight'">
					<mat-label translate>coil.calculator.weight.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.999" [min]="0" [decimalCount]="3"
						[formControl]="additionalDataWeightFormControl" (input)="additionalDataChanged($event)"
						required>
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
					<mat-error *ngIf="additionalDataWeightFormControl.hasError('required')">
						<span translate>coil.calculator.weight.mandatory</span>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="calculator-block-info-grid">
				<mat-radio-button value="coilLength" class="calculator-block-info-item">
					<span translate>coil.calculator.length</span>
				</mat-radio-button>
				<mat-form-field
					*ngIf="additionalDataChoiceFormControl.value === 'coilLength'">
					<mat-label translate>coil.calculator.length.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
						[formControl]="additionalDatLengthFormControl" (input)="additionalDataChanged($event)"
						required>
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
					<mat-error *ngIf="additionalDatLengthFormControl.hasError('required')">
						<span translate>coil.calculator.length.mandatory</span>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="calculator-block-info-grid">
				<mat-radio-button value="specificWeight" class="calculator-block-info-item">
					<span translate>coil.calculator.specific.weight</span>
				</mat-radio-button>
				<mat-form-field
					*ngIf="additionalDataChoiceFormControl.value === 'specificWeight'">
					<mat-label translate>coil.calculator.specific.weight.label</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false"
						autocomplete="off" [maxlength]="10" [max]="999999.99" [min]="0" [decimalCount]="2"
						[formControl]="additionalDataSpecificWeightFormControl" (input)="additionalDataChanged($event)"
						required>
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
					<mat-error *ngIf="additionalDataSpecificWeightFormControl.hasError('required')">
						<span translate>coil.calculator.specific.weight.mandatory</span>
					</mat-error>
				</mat-form-field>
			</div>
		</mat-radio-group>
	</form>
	<div class="calculator-result-block">
		<div class="calculator-block-subtitle" translate>coil.calculator.result</div>
		<ng-container *ngIf="!isLoading; else loading">
			<div class="calculator-details-text" *ngIf="!coilCalculatorResult.resultCalculated" translate>
				coil.calculator.no.result.text</div>
			<div class="calculator-block-result-grid" *ngIf="coilCalculatorResult.resultCalculated">
				<div class="calculator-block-info-item"
					*ngIf="additionalDataChoiceFormControl.value !== 'coilOuterDiameter'">
					<div class="calculator-result-block-label" translate>coil.calculator.outer.diameter.label</div>
					<div class="calculator-result-block-value">{{coilCalculatorResult.coilOuterDiameter |
						copoNumber:'diameter'}}</div>
				</div>
				<div class="calculator-block-info-item" *ngIf="additionalDataChoiceFormControl.value !== 'coilWeight'">
					<div class="calculator-result-block-label" translate>coil.calculator.weight.label</div>
					<div class="calculator-result-block-value">{{coilCalculatorResult.coilWeight | copoNumber:'weight'}}
					</div>
				</div>
				<div class="calculator-block-info-item" *ngIf="additionalDataChoiceFormControl.value !== 'coilLength'">
					<div class="calculator-result-block-label" translate>coil.calculator.length.label</div>
					<div class="calculator-result-block-value">{{coilCalculatorResult.coilLength | copoNumber:'length-m'}}
					</div>
				</div>
				<div class="calculator-block-info-item" *ngIf="additionalDataChoiceFormControl.value !== 'specificWeight'">
					<div class="calculator-result-block-label" translate>coil.calculator.specific.weight.label</div>
					<div class="calculator-result-block-value">{{coilCalculatorResult.specificWeight |
						copoNumber:'linearMassDensity'}}</div>
				</div>
			</div>
		</ng-container>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
	</div>
</div>